if (!customElements.get('dialog-popup')) {
  class DialogPopup extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // Elements
      this.trigger = this.querySelector('[data-dialog-popup="trigger"]');
      this.close = this.querySelector('[data-dialog-popup="close"]');
      this.dialog = this.querySelector('[data-dialog-popup="dialog"]');

      // Events
      this.trigger.addEventListener('click', () => {
        this.openModal();
      });

      this.close.addEventListener('click', () => {
        this.closeModal();
      });
    }

    openModal() {
      this.dialog.showModal();
    }

    closeModal() {
      this.dialog.close();
    }
  }

  customElements.define('dialog-popup', DialogPopup);
}
